<script lang="ts">
  import type { Snippet } from "svelte";
  import type { StatuteBill } from "../types";
  import Info from "~icons/ph/info-bold";
  import { formatGbp } from "../../../lib/formatting";

  let {
    statuteBill,
    payoutAmount,
    children,
    class: className,
  }: {
    statuteBill: StatuteBill;
    payoutAmount: number;
    children?: Snippet;
    class?: string;
  } = $props();
</script>

<div class="border rounded-lg p-4 {className}">
  <img src={statuteBill.logo} alt="" class="mx-auto mb-4 w-48 h-auto" />
  <div class="divide-y">
    {#each Object.entries(statuteBill.summary) as [heading, lines] (heading)}
      <div class="py-4 first:pt-0">
        <div class="text-xs text-gray-500 font-medium mb-1">{heading}</div>
        <dl class="flex flex-col gap-1">
          {#each lines as [label, amount, note] (label)}
            <div class="flex justify-between items-center gap-4">
              <dt>
                {label}
                {#if note}
                  <button type="button" class="tooltip tooltip-top align-text-top" data-tip={note} aria-label={note}>
                    <Info class="text-blue-600 w-4.5 h-4.5" />
                  </button>
                {/if}
              </dt>
              <dd class="shrink-0">{formatGbp(amount)}</dd>
            </div>
          {/each}
        </dl>
      </div>
    {/each}
    <div class="pt-4">
      <dl class="flex justify-between font-bold">
        <dt>You’ll receive</dt>
        <dd>{formatGbp(payoutAmount)}</dd>
      </dl>
    </div>
  </div>

  {@render children?.()}
</div>
